// Free-disk-space check for the offline audiobook download.
//
// Backed by the in-tree native DiskSpace plugin (android/app/.../DiskSpacePlugin.java),
// which reports free/total bytes on the internal, app-private partition — the SAME
// volume that Filesystem Directory.Data and Preferences write to.
//
// Deliberate degrade-open contract: getFreeDiskBytes() returns null on the web (no
// native plugin) AND on any native failure. Callers must treat null as "no data →
// skip the space check and allow the download", never as "block". A hard block on
// missing data would be worse UX than today's no-check behaviour.

import { Capacitor, registerPlugin } from '@capacitor/core';

const DiskSpace = registerPlugin('DiskSpace');

// { freeBytes, totalBytes } on native when the check succeeds, or null on web /
// on any error. Never throws.
export async function getFreeDiskBytes() {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { freeBytes, totalBytes } = await DiskSpace.getFreeDiskSpace();
    return { freeBytes, totalBytes };
  } catch (err) {
    console.warn('[diskSpace] failed to read free disk:', err);
    return null;
  }
}
